module.exports = __webpack_public_path__ + "static/img/4.0dca8c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/places/4.jpg
// module id = n3fj
// module chunks = 1